var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1925 9.1325L10.315 12.1175M10.3075 3.8825L5.1925 6.8675M14.5 2.75C14.5 3.99264 13.4926 5 12.25 5C11.0074 5 10 3.99264 10 2.75C10 1.50736 11.0074 0.5 12.25 0.5C13.4926 0.5 14.5 1.50736 14.5 2.75ZM5.5 8C5.5 9.24264 4.49264 10.25 3.25 10.25C2.00736 10.25 1 9.24264 1 8C1 6.75736 2.00736 5.75 3.25 5.75C4.49264 5.75 5.5 6.75736 5.5 8ZM14.5 13.25C14.5 14.4926 13.4926 15.5 12.25 15.5C11.0074 15.5 10 14.4926 10 13.25C10 12.0074 11.0074 11 12.25 11C13.4926 11 14.5 12.0074 14.5 13.25Z",
    stroke: "#003478",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareicon);
export default __webpack_public_path__ + "static/media/share icon.b54ec806ef039e101009157976cb33c5.svg";
export { ForwardRef as ReactComponent };